const descriptionElement = document.getElementById('desc-content');
const readMoreButton = document.getElementById('readmore');
let isExpaned = false;

readMoreButton.addEventListener('click', function() {
  if (isExpaned) {
	descriptionElement.style.maxHeight = "40rem";
    descriptionElement.style.overflow = 'hidden';
    readMoreButton.innerHTML = 'Read more <i class="fa fa-chevron-down"></i>';
		descriptionElement.scrollIntoView({ behavior: 'smooth' });
  } else {
    descriptionElement.style.maxHeight = "none";
    descriptionElement.style.overflow = 'visible';
    readMoreButton.innerHTML = 'Show less <i class="fa fa-chevron-up"></i>';
  }
	isExpaned = !isExpaned;
});